export default {
  noData: 'Không có dữ liệu',
  EmptyData: 'Chưa có dữ liệu',
  search: 'Tìm kiếm...',
  FeaturesIsDeveloping: 'Tính năng đang phát triển',
  enterSearchText: 'Nhập nội dung cần tìm kiếm',
  command: {
    add: 'Thêm',
    edit: 'Sửa',
    update: 'Cập nhật',
    delete: 'Xóa',
    deleteField: 'Xóa thông tin',
    duplicate: 'Nhân bản',
    more: 'Thêm nữa...',
    arrange: 'Sắp xếp',
    save: 'Lưu',
    saveNew: 'Lưu & Thêm',
    close: 'Đóng',
    hide: 'Ẩn',
    send: 'Gửi',
    show: 'Hiện',
    help: 'Giúp',
    cancel: 'Hủy',
    accept: 'Đồng ý',
    saveAndNew: 'Lưu và thêm mới',
    confirm: 'Xác nhận',
    notConfirm: 'Không xác nhận',
    export: 'Xuất khẩu',
    finish: 'Hoàn thành',
    load: 'Nạp',
    print: 'In',
    filter: 'Lọc',
    refresh: 'Nạp',
    setting: 'Thiết lập',
    default: 'Mặc định',
    list: 'Danh sách',
    addDetail: 'Thêm dòng',
    addDetailShortKey: 'Thêm dòng (F9)',
    import: 'Nhập khẩu',
    logout: 'Đăng xuất',
    next: 'Tiếp theo',
    back: 'Quay lại',
    move: 'Di chuyển',
    minimize: 'Thu gọn',
    inactive: 'Ngừng theo dõi',
    ignore: 'Bỏ qua',
    checkNow: 'Kiểm tra ngay',
    longCancel: 'Hủy bỏ',
    enact: 'Ban hành',
    historyEnact: 'Lịch sử ban hành',
    return: 'Gửi trả',
    returnRequest: 'Gửi phản hồi',
    select: 'Chọn',
    addContent: 'Chọn thêm nội dung',
    revoke: 'Thu hồi',
    deliver: 'Giao dự toán',

    /*Excel*/
    Bold: 'bold',
    Italic: 'italic',
    Indent: 'indent',
    Outdent: 'outdent',
    CommentExcel: 'CommentExcel',
    FontSize: 'fontSize',
    FontFamily: 'fontFamily',
    FormatCell: 'formatCell',
    BorderSetting: 'BorderSetting',
    FreezePanel: 'freezePanes',
    Unfreeze: 'unfreeze',
    Underline: 'underline',
    Wordwrap: 'wordwrap',
    Cellmerge: 'cellmerge',
    BackColor: 'backColor',
    ForeColor: 'foreColor',

    HalignLeft: 'halign-left',
    HalignCenter: 'halign-center',
    HalignRight: 'halign-right',
    ValignTop: 'valign-top',
    ValignCenter: 'valign-center',
    ValignBottom: 'valign-bottom',
    //Bộ setting Border toolbar workbook
    BorderBottom: 'BorderBottom',
    BorderTop: 'BorderTop',
    BorderLeft: 'BorderLeft',
    BorderRight: 'BorderRight',
    BorderNone: 'BorderNone',
    BordersAll: 'BordersAll',
    BorderOutside: 'BorderOutside',
    BorderThickOutside: 'BorderThickOutside',
    BorderDoubleBottom: 'BorderDoubleBottom',
    BorderThickBottom: 'BorderThickBottom',
    BorderTopAndBottom: 'BorderTopAndBottom',
    BorderTopAndThickBottom: 'BorderTopAndThickBottom',
    BorderTopAndDoubleBottom: 'BorderTopAndDoubleBottom',
    Signature: 'Signature',

    Undo: 'Undo',
    Redo: 'Redo',
    view: 'Xem',
    exportExcel: 'Xuất Excel',
    showHideColumns: 'Ẩn/hiện cột',
    fileAttach: 'Đính kèm',
    selectCell: 'Chọn ô dữ liệu',
    explanation: 'Thuyết minh',
    importExcel: 'Nhập Excel',
  },
  List: {
    SearchEmptyText: 'Tìm kiếm',
    SearchOrganization: 'Nhập mã QHNS hoặc tên đơn vị cần tìm kiếm',
    SearchCodeOrName: 'Nhập mã, tên nội dung cần tìm kiếm',
    SearchEstimate: 'Nhập nội dung cần tìm kiếm',
  },
  module: {
    employee: 'Nhân viên',
    revenueOther: 'nội dung thu khác',
    budgetKindItem: 'Loại khoản',
    employeeType: 'Loại cán bộ',
    payrollItem: 'Khoản lương',
    inventoryItem: 'Vật tư, Hàng hóa',
    buPlanWithDraw: 'Rút dự toán tiền gửi',
    bUTransfer: 'Chuyển khoản kho bạc vào tài khoản tiền gửi',
    accountingObject: 'Cán bộ',
    department: 'Phòng/ban',
    account: 'Tài khoản',
    currency: 'Loại tiền',
    baWithdraw: 'Chi tiền gửi',
    inventoryCategory: 'Loại vật tư, hàng hóa',
    stock: 'Kho',
    buPlanReceipt: 'Nhận dự toán',
    dictionaryChapter: 'Chương',
    budgetProvide: 'Mã dự phòng',
    typeOfFund: 'Loại quỹ',
    bankInfoCategory: 'Loại tài khoản tiền gửi kho bạc',
    budgetGroupItem: 'Nhóm mục chi',
    budgetSourceProperty: 'Tính chất nguồn kinh phí',
    cAReceipt: 'Phiếu thu',
    budgetSource: 'Nguồn kinh phí',
    bankInfo: 'Tài khoản ngân hàng, kho bạc',
    bUVoucherList: 'Bảng kê chứng từ thanh toán',
    budgetItem: 'Mục - Tiểu mục',

    bUPlanAdjustment: 'Điều chỉnh dự toán',
    budgetKindItem: 'Loại - Khoản',
    sUTransfer: 'Điều chuyển CCDC',
    sUIncrement: 'Ghi tăng CCDC',
    sUDecrement: 'Ghi giảm CCDC',
    bUPlanWDAdjustment: 'Điều chỉnh kinh phí',
    pUInvoice: 'Hóa đơn mua hàng',
    iNTransfer: 'Chuyển kho',
    iNAdjustment: 'Điều chỉnh tồn kho',
    statistic: 'Mã thống kê',
    purchasePurpose: 'Nhóm HH, DV mua vào',
    cAPayment: 'Phiếu chi',
    dictionaryFees: 'Phí, Lệ phí',
    dictionaryPatternRegular: 'Mẫu dự toán chi thường xuyên',
    DictionaryPresentList: 'Thuyết minh',
    DictionaryReportCustomList: 'Mẫu in',
    accountTransfer: 'Tài khoản kết chuyển',
    bADeposit: 'Phiếu thu',
    cAReceiptSale: 'Phiếu thu bán hàng',
    sAInvoice: 'Bán hàng chưa thu tiền',
    bABankTransfer: 'Chuyển tiền nội bộ',
    bUBudgetReserve: 'Dự toán giữ lại',
    gLVoucher: 'Chứng từ nghiệp vụ khác',
    activity: 'Hoạt động',
    task: 'Nhiệm vụ',
    customerVendor: 'Khách hàng, nhà cung cấp',
    accountingObjectCategory: 'Loại khách hàng, nhà cung cấp',
    invoiceFormNumber: 'Mẫu số hóa đơn',
    voucherType: 'Loại chứng từ',
    sAReturn: 'Hàng bán trả lại',
    gLVoucher: 'Chứng từ nghiệp vụ khác',
    activity: 'Hoạt động',
    bUCommitmentRequest: 'Đề nghị cam kết chi',
    bUCommitmentAdjustment: 'Điều chỉnh cam kết chi',
    bUOpeningCommitment: 'Nhập cam kết chi ban đầu',
    project: 'Dự án',
    targetProgram: 'Chương trình mục tiêu',
    projectBudgetDetail: 'Chi tiết tổng mức đầu tư',
    contract: 'Hợp đồng',
    topic: 'Đề tài',
    gLVoucherList: 'Bảng tổng hợp chứng từ',
    workItem: 'Công trình, HMCT',
    BUTransferPurchase: 'Chuyển khoản kho bạc mua vật tư hàng hóa',
    INInwardFromINAdjustment: 'Nhập kho từ điều chỉnh tồn kho',
    INInwardFromINAdjustmentChangeAmount: 'Nhập kho từ điều chỉnh tồn kho (Có điều chỉnh giá trị)',
    INOutwardFromINAdjustment: 'Xuất kho từ điều chỉnh tồn kho',
    INOutwardFromINAdjustmentChangeAmount: 'Xuất kho từ điều chỉnh tồn kho (Có điều chỉnh giá trị)',
    FAVoucherDepreciation: 'Lấy hao mòn tự nhiên TSCĐ từ QLTS.VN',
    FAVoucherIncreament: 'Ghi tăng TSCĐ từ QLTS.VN',
    FAVoucherAdjustment: 'Đánh giá lại TSCĐ từ QLTS.VN',
    FAVoucherDepreciate: 'Lấy khấu hao TSCĐ từ QLTS.VN',
    FAVoucherDecrement: 'Ghi giảm TSCĐ từ QLTS.VN',
    bATransfer: 'Tiền đang chuyển',
    bUPlanImport: 'Nhập dự toán',
    cRERepList: 'Báo cáo tài chính',
    openingSupplyEntry: 'Công cụ dụng cụ',
    autoBusiness: 'Định khoản tự động',
    fundStructure: 'Cơ cấu vốn',
    cRERepExportList: 'Nộp báo cáo cho kho bạc',
    defaultAccount: 'Tài khoản ngầm định',
    cRERepSettlement: 'Báo cáo quyết toán',
    cAReceiptSale: 'Thu tiền khách hàng',
    salaryScale: 'Ngạch lương',
    pAOption: 'Quy định lương, thuế, bảo hiểm',
    toolType: 'Loại công cụ dụng cụ',
    toolList: 'Công cụ dụng cụ',
    dictionaryRegular: 'Chi thường xuyên',
    dictionaryBusiness: 'Thu HĐSN và dịch vụ',
    criteria: 'Tiêu chí thống kê',
    expenseInvest: 'Chi đầu tư và phát triển',
    dictionaryExpenseOther: 'nội dung chi khác',
    projectExpense: 'Chương trình mục tiêu, dự án',
    dictionaryRevenueAgency: 'Cơ quan thu',
    dictionaryRevenueBudget: 'Thu ngân sách Nhà nước',
    dictionaryRevenueBudgetWards: 'Thu ngân sách Nhà nước',
    calculationBasis: 'nội dung cơ sở tính',
    dictionaryPresentDatatable: 'Trường dữ liệu',
    beforeDataRevenueBudget: 'Thu ngân sách Nhà nước',
    beforeDataRevenueOther: 'Thu khác',
    beforeDataRevenueFees: 'Thu Phí, Lệ phí',
    beforeDataRevenueBusiness: 'Thu HĐSN, Dịch vụ',
    expenseInvestBefore: 'Chi đầu tư phát triển',
    expenseInvestBeforeField: 'Chi đầu tư phát triển (theo lĩnh vực)',
    expenseInvestBeforeCapital: 'Chi đầu tư phát triển (theo nguồn)',
    expenseInvestBeforeProject: 'Chi đầu tư phát triển (theo dự án)',
    expenseActiveInvestBefore: 'Chi HĐSN, Dịch vụ (ĐT)',
    expenseActiveRegularBefore: 'Chi HĐSN, Dịch vụ (TX)',
    expenseActiveSalaryBefore: 'Chi HĐSN, Dịch vụ (CCTL)',
    expenseFeesBefore: 'Chi từ Phí để lại (TX)',
    investFeesBefore: 'Chi từ Phí để lại (ĐT)',
    salaryFeesBefore: 'Chi từ Phí để lại (CCTL)',
    expenseOtherBefore: 'Chi khác',
    expenseProjectBefore: 'Chi CTMT, mục tiêu khác',
    expenseRegularBefore: 'Chi thường xuyên',
    beforeDataCalculationBasis: 'Cơ sở tính',
    OrganizationGroup: 'Nhóm đơn vị',
  },
  Text: {
    Estimate: 'Lập dự toán',
    RequestSubmit: 'Yêu cầu nộp',
    CancelCompletion: 'Hủy hoàn thành',
    CreateSubmitEstimate: 'Lập và Tạo lần nộp',
    ContinueCreateEstimate: 'Tiếp tục lập dự toán',
    CreateSubmitEstimateFinance: 'Lập và Tạo lần nộp dự toán nhu cầu',
  },
  HeaderGrid: {
    ActionColumn: 'Chức năng',
  },
  ContentDictionary: {
    AddContent: 'Thêm mới',
    GroupContent: 'Gộp nội dung',
    RejectContent: 'Từ chối',
    InsertApprove: 'Thêm mới (Ctrl + Insert)',
    MergeApprove: 'Gộp nội dung (Ctrl + G)',
    RefuseApprove: 'Từ chối (Ctrl + Delete)',
  },
  Setting: {
    Infomation: 'infor',
    Display: 'display',
    HelpInstruct: 'instruct',
    ExpenseInvestMapping: 'expenseInvestMapping',
    SortOrganization: 'sortOrganization',
    LayoutSetting: 'layoutSetting'
  },
  /**
   * Thông tin màn hình
   */
  screenNameReport: {
    SummaryEstimateArrgratePTC: "SummaryEstimateArrgratePTC"
  },
  DictionaryLogScreen: {
    dictionarySource: 'Nguồn kinh phí',
    DictionaryBusiness: ' thu HDSN và dịch vụ',
    dictionaryFees: 'phí, lệ phí',
    dictionaryChapter: 'Chương',
    dictionaryKind: 'Loại - khoản',
    budgetItem: 'mục - tiểu mục',
    dictionaryRevenueBudget: 'thu NSNN',
    expenseInvest: 'dự án đầu tư phát triển',
    dictionaryRegular: ' nhiệm vụ chi thường xuyên',
    project: 'CTMT, mục tiêu khác',
    dictionaryPatternRegular: 'Mẫu dự toán Chi TX',
    dictionaryPresent: 'mẫu thuyết minh',
    revenueOther: 'thu khác', // thu khác
    //chi khác
    dictionaryExpenseOther: 'chi khác',
    //cơ sở tính
    criteria: 'tiêu chí thống kê',
  },
  EnactContentDetail: {
    dictionary_fees: 'phí, lệ phí',
    dictionary_revenue_other: 'nội dung thu khác',
    dictionary_revenue_budget: 'nội dung thu NSNN',
    dictionary_business: 'nội dung thu',
    dictionary_regular: ' nhiệm vụ',
    dictionary_project: 'CTMT, dự án',
    dictionary_expense_other: 'nội dung chi khác',
    dictionary_invest: 'dự án',
    explanation_form: 'thuyết minh',
    calculation_basis: 'cơ sở tính',
    dictionary_criteria: 'tiêu chí thống kê',
    dictionary_pattern_regular: 'mẫu dự toán chi thường xuyên',
    invest: 'dự án',
    project: 'CTMT, dự án',
    expense_other: 'nội dung chi khác'
  },
  EnactTab: {
    revenueFeeEnact: 'phí, lệ phí',
    revenueOtherEnact: 'nội dung thu khác',
    revenueBudgetEnact: 'nội dung thu NSNN',
    revenueBusinessEnact: 'nội dung thu',
    expenseRegularEnact: ' nhiệm vụ',
    expenseProjectEnact: 'CTMT, dự án',
    expenseOtherEnact: 'nội dung chi khác',
    expenseInvestEnact: 'dự án',
    explanationFormEnact: 'thuyết minh',
    calculationBasisEnact: 'cơ sở tính',
    criteriaEnact: 'tiêu chí thống kê',
    dictionary_pattern_regular: 'mẫu chi thường xuyên',
  },
  EstimateType: {
    EstimateFees: 'Thu - chi từ nguồn phí, lệ phí',
    estimateRegularTemplate: 'Chi thường xuyên',
    EstimateBusiness: 'Thu - chi từ nguồn hoạt động sự nghiệp, dịch vụ',
    EstimateRevenueOthers: 'Thu khác theo quy định của pháp luật',
    EstimateExpenseOthers: 'Chi khác theo quy định của pháp luật',
    EstimateProjects: 'Chi CTMT, mục tiêu khác',
    EstimateRevenueBudgets: 'Thu NSNN',
    EstimateInvests: 'Chi đầu tư',
    estimateInvest: 'Chi đầu tư',
    EstimateRegularTemplates: 'Chi thường xuyên',
    estimateProject: 'Chi CTMT, mục tiêu khác',
    estimateRevenueBusiness: 'Thu từ nguồn hoạt động sự nghiệp, dịch vụ',
    estimateRevenueOther: 'Thu khác theo quy định của pháp luật',
    estimateExpenseOther: 'Chi khác theo quy định của pháp luật',
    estimateBudget: 'Thu NSNN',
    estimateExpenseFee: 'Chi từ nguồn phí, lệ phí',
    estimateExpenseBusiness: 'Chi từ nguồn hoạt động sự nghiệp, dịch vụ',
    estimateRevenueFee: 'Thu từ nguồn phí, lệ phí',

  },

  EstimateTypeNameLog: {
    EstimateFees: 'phí, lệ phí',
    estimateRegularTemplate: 'nhiệm vụ',
    EstimateBusiness: 'nội dung thu',
    EstimateRevenueOthers: 'nội dung thu khác',
    EstimateExpenseOthers: 'nội dung chi khác',
    EstimateProjects: 'CTMT, dự án',
    EstimateRevenueBudgets: 'nội dung thu NSNN',
    EstimateInvests: 'dự án',
    estimateInvest: 'dự án',
    EstimateRegularTemplates: 'nhiệm vụ',
    estimateProject: 'CTMT, dự án',
    estimateRevenueBusiness: 'nội dung thu',
    estimateRevenueOther: 'nội dung thu khác',
    estimateExpenseOther: 'nội dung chi khác',
    estimateBudget: 'nội dung thu NSNN',
    estimateExpenseFee: 'phí, lệ phí',
    estimateExpenseBusiness: 'nội dung thu',
    estimateRevenueFee: 'phí, lệ phí',

  },
};
